/**
 * Created by courtney_adesile on 25/09/19.
 */

(function () {
    // Set globals
    var REP_SYNCED_KEY = '_img_rep_synced';
    var workflowPromises = new Set();

    function queueWorkflowCall(promise) {
        workflowPromises.add(promise);

        promise.then(function() {
            workflowPromises.delete(promise);
        });

        return promise;
    }

    /**
     * Primary initialization handler to kick off rendering
     */
    function init() {
        // router.js / router-other-locations.js rewrite the cart's `customer`
        // attribute on these pages (router.js replaces it outright, without the
        // cookie's rep). Forget any earlier sync and leave the cookie sync to the
        // page they redirect to, so it re-checks the cart after their write.
        if (isRouterPage()) {
            removeSessionValue(REP_SYNCED_KEY);
        }

        // Checks to see if Rep email is passed via Querystring, if so attempts to set Rep cookies
        if (urlQuery('rep') || urlQuery('repEmail')) {
            getRepFromQuerystring('rep');
            getRepFromQuerystring('repEmail');
        } else if (!isRouterPage()) {
            // No querystring rep: copy an existing rep cookie (ours, or Drupal's
            // shared .imgacademy.com one) onto the cart, once per cart + rep.
            syncRepFromCookie();
        }
        /*
        setTimeout(function() {
            Promise.all(workflowPromises).finally(autoAddProduct);
        }, 500);
        */
    }

    /**
     * Vanilla cookie read — no jQuery dependency, this script may run on
     * pages where jQuery is not loaded.
     *
     * @param name
     */
    function readCookie(name) {
        if (typeof document === 'undefined' || !document.cookie) {
            return null;
        }

        var match = document.cookie.match(
            new RegExp('(?:^|; )' + name.replace(/([.*+?^${}()|[\]\\])/g, '\\$1') + '=([^;]*)')
        );

        return match ? decodeURIComponent(match[1]) : null;
    }

    /**
     * Cookie domain for rep cookies. On *.imgacademy.com the cookie is scoped
     * to the root domain so Shopify and Drupal share ONE cookie instead of
     * each writing its own. Elsewhere (stage imgor.myshopify.com, preview
     * domains) no domain is set: myshopify.com is a public suffix, so a
     * `.myshopify.com` domain would be rejected by the browser.
     */
    function cookieDomain() {
        return /(^|\.)imgacademy\.com$/.test(window.location.hostname) ? '.imgacademy.com' : null;
    }

    /**
     * Vanilla cookie write with optional expiry, matching the previous
     * `$.cookie(name, value, { expires: days, path: '/' })` behavior.
     *
     * @param name
     * @param value
     * @param days
     */
    function writeCookie(name, value, days) {
        if (typeof document === 'undefined') {
            return;
        }

        var expires = '';
        if (typeof days === 'number') {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = '; expires=' + date.toUTCString();
        }

        var domain = cookieDomain();
        if (domain) {
            // Drop the host-only copy (e.g. shop.imgacademy.com) older versions
            // of this script wrote; it is a separate cookie from the root-domain
            // one and would otherwise shadow it as a duplicate.
            document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
        }

        document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/' + (domain ? '; domain=' + domain : '');
    }

    /**
     *
     * @param callback
     */
    function getCart(callback) {
        var call = fetch('/cart.js', {
            method: 'GET',
            headers: { 'Accept': 'application/json' }
        })
        .then(function (response) { return response.json(); })
        .then(function (data) { callback(data); })
        .catch(function (err) {
            console.log('Error retrieving cart:', err);
            callback(err);
        });

        return queueWorkflowCall(call);
    }

    /**
     *
     * @param shopifyCart
     */
    function updateRepInformation(shopifyCart) {
        if (!shopifyCart || !shopifyCart.attributes) {
            return;
        }

        var customer = {
            representative_email: '',
            representative_data: '',
        };

        if(typeof(shopifyCart.attributes.customer) !== 'undefined'){
            try {
                customer = JSON.parse(shopifyCart.attributes.customer) || customer;
            } catch (e) {
                console.log('Existing customer attribute is not valid JSON; replacing', e);
            }
        }

        var repEmail = readCookie('_img_rep');
        if(repEmail) {
            customer.representative_email = repEmail;
        }

        var repData = readCookie('_img_rep_data');
        if(repData) {
            customer.representative_data = repData;
        }

        // Only post `customer`: posting the whole attributes snapshot could
        // revert participants etc. written by other scripts since we read it.
        writeAttributesToCart({ customer: JSON.stringify(customer) }).then(function () {
            markRepSynced(repEmail);
        }).catch(function () {});
    }

    /**
     * Cookie-only path: when the cart doesn't already carry the cookie's rep,
     * write it. A sessionStorage marker (cart token + rep email) skips even the
     * /cart.js read on later pages; a new cart or a different rep re-syncs.
     */
    function syncRepFromCookie() {
        var repEmail = readCookie('_img_rep');
        if (!repEmail || readSessionValue(REP_SYNCED_KEY) === repSyncedValue(repEmail)) {
            return;
        }

        getCart(function (shopifyCart) {
            if (!shopifyCart || !shopifyCart.attributes) {
                return;
            }

            var existing = null;
            try {
                existing = shopifyCart.attributes.customer ? JSON.parse(shopifyCart.attributes.customer) : null;
            } catch (e) {
                existing = null;
            }

            if (existing && existing.representative_email === repEmail) {
                markRepSynced(repEmail);
                return;
            }

            updateRepInformation(shopifyCart);
        });
    }

    function repSyncedValue(repEmail) {
        return (readCookie('cart') || '') + '|' + repEmail;
    }

    function markRepSynced(repEmail) {
        if (repEmail && !isRouterPage()) {
            writeSessionValue(REP_SYNCED_KEY, repSyncedValue(repEmail));
        }
    }

    // sessionStorage can throw (private mode, blocked storage); the marker is
    // only an optimisation, so failures just mean another /cart.js read.
    function readSessionValue(key) {
        try {
            return window.sessionStorage.getItem(key);
        } catch (e) {
            return null;
        }
    }

    function writeSessionValue(key, value) {
        try {
            window.sessionStorage.setItem(key, value);
        } catch (e) {}
    }

    function removeSessionValue(key) {
        try {
            window.sessionStorage.removeItem(key);
        } catch (e) {}
    }

    // /pages/router and /pages/router-other-locations
    function isRouterPage() {
        return /^\/pages\/router(-other-locations)?\/?$/.test(window.location.pathname);
    }

    /**
     *
     * @param attributes
     */
    function writeAttributesToCart(attributes) {
        var postData = {
            attributes: attributes,
        };

        var call = fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(postData)
        })
        .then(function (response) {
            if (!response.ok) {
                throw new Error('Cart update failed: ' + response.status);
            }
            return response.json();
        })
        .catch(function (err) {
            console.log('Error while adding attribute to shopify cart', err);
            throw err;
        });

        return queueWorkflowCall(call);
    }

    function autoAddProduct() {
        var productAddToCart = document.querySelector('form[action="/cart/add"]');
        if (!productAddToCart) {
            return;
        }

        var isAutoAdd = urlQuery('autoadd');
        if (isAutoAdd !== 'true') {
            return;
        }

        var params = {};
        new FormData(productAddToCart).forEach(function (value, key) {
            params[key] = value;
        });

        params.properties = {
            _participant_id: urlQuery('participant_id') || 'guest',
        };

        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(params)
        })
        .then(function () {
            window.location = '/cart';
        })
        .catch(function (err) {
            console.log('Error auto-adding product to cart:', err);
        });
    }

    /**
     *
     */
    function getRepFromQuerystring(key) {
        console.log('Rep key:', key);
        var email = urlQuery(key);

        console.log('Rep email from querystring:', email);

        // if email provided via querystring, run process
        if(email) {
            getRepInfo(email);
        }
    }

    /**
     *
     * @param email
     */
    function getRepInfo(email) {
        var repApiBase = determineApiDomain();

        var call = fetch(repApiBase + '/_ajax_dispatch/img_rep_data?rep_email=' + email, {
            method: 'GET',
            headers: { 'Accept': 'application/json' }
        })
        .then(function (response) { return response.json(); })
        .then(function (data) {
            if(typeof(data.status) !== 'undefined'){
                if(data.status){
                    setRepCookies(data.email, data, getCart);
                }
                else {
                    // console.log('rep not found:', email);
                }
            }
        })
        .catch(function (err) {
            console.log('Error retrieving rep info:', err);
        });

        return queueWorkflowCall(call);
    }

    /**
     *
     * @param email
     * @param data
     */
    function setRepCookies(email, data, callback) {
        if(typeof(email) !== 'undefined'){
            // 90-day life + root path so a return visit (new session, no ?rep=)
            // still carries the rep to /cart and checkout for sale credit.
            writeCookie('_img_rep', email, 90);
        }

        if(typeof(data) !== 'undefined'){
            writeCookie('_img_rep_data', JSON.stringify(data), 90);
        }


        if(typeof(callback) !== 'undefined'){
            callback(updateRepInformation);
        }
    }

    /**
     *
     * @returns {*}
     */
    function determineApiDomain() {
        switch(window.location.host){
            case 'imgor.myshopify.com':
                return 'https://stage.imgacademy.com';
            default:
                return 'https://www.imgacademy.com';
        }
    }

    /**
     * Retrieves URL parameters based on a given parameter name
     *
     * @param {*} name
     */
    function urlQuery(name) {
        var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
        if (results === null) {
            return null;
        }
        return decodeURIComponent(results[1]) || null;
    }

    init();
})();
